import {AppState} from '@/store/state';
import {UiState} from '@/store/ui/state';
import {Component, HostBinding, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppService} from '@services/app.service';
import {User} from 'firebase/auth';
import {Observable} from 'rxjs';

const BASE_CLASSES = 'main-sidebar elevation-4';
@Component({
    selector: 'app-menu-sidebar',
    templateUrl: './menu-sidebar.component.html',
    styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit {
    @HostBinding('class') classes: string = BASE_CLASSES;
    public ui: Observable<UiState>;
    public user?: User;
    public menu = MENU;

    constructor(
        public appService: AppService,
        private store: Store<AppState>
    ) {}

    ngOnInit() {
        this.ui = this.store.select('ui');
        this.ui.subscribe((state: UiState) => {
            this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
        });
        this.user = this.appService.user;
    }
}

export const MENU = [
    {
    name: "Event Details",
    iconClasses: "fas fa-tachometer-alt",
    children: [
      {
        name: "Add New Event",
        iconClasses: "fa fa-users",
        path: ["/main/event-creation"],
      },
      {
        name: "View Event Details",
        iconClasses: "fa fa-table",
        path: ["/main/event-list-table"],
      },

    ]
  },
  {
    name: 'Participants Details',
    iconClasses: 'fas fa-tasks',
    path: ['/main/booking-details']
  },
   {
    name: 'Volunteer Details',
    iconClasses: 'fas fa-users',
    path: ['/main/volunteer-details']
  },
  {
    name: 'Feedback Details',
    iconClasses: 'fas fa-comments',
    path: ['/main/feedback-details']
  },
];
